module.exports = __webpack_public_path__ + "img/item.bf464cf8.svg";